'use client'

import { useEffect, useState } from 'react'

const FALLBACK_AGENT_NAME = 'Samantha'

export function useMasterAgentName() {
  const [agentName, setAgentName] = useState(FALLBACK_AGENT_NAME)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const existingName =
      String((window as any).__hubeeMasterAgentName || '').trim() ||
      String(window.localStorage.getItem('hubee:master-agent-name') || '').trim()

    if (existingName) {
      setAgentName(existingName)
    }

    function handleAgentName(event: Event) {
      const customEvent = event as CustomEvent<{ name?: string }>
      const nextName = String(customEvent.detail?.name || '').trim()

      if (nextName) {
        setAgentName(nextName)
      }
    }

    window.addEventListener('samantha:master-agent-name', handleAgentName)

    return () => {
      window.removeEventListener('samantha:master-agent-name', handleAgentName)
    }
  }, [])

  return agentName
}